let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1AYDD")).then(() => parcelRequire('5SliH'));